import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography, IconButton, Box, Divider } from "@mui/material";

export default function BackWithArrow({ onBack, disabled = false }) {
  // Handle the click event for both the icon and text
  const handleBack = () => {
    if (!disabled && onBack) {
      onBack(); // This will close whatever the parent component needs to close
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          pl: 1,
          bgcolor: "transparent",
          minHeight: 64,
        }}
      >
        <IconButton
          edge="start"
          onClick={handleBack}
          disabled={disabled}
          sx={{ mr: 1 }}
        >
          <ArrowBackIcon sx={{ color: "#4F46E5" }} />
        </IconButton>
        <Typography
          variant="button"
          sx={{
            fontWeight: 600,
            fontSize: 18,
            cursor: disabled ? "default" : "pointer",
            color: "#4F46E5", // Set text color
          }}
          onClick={handleBack}
        >
          Back
        </Typography>
      </Box>
      {/* Full horizontal line below Back text */}
      <Divider sx={{ width: "100%", borderColor: "#E0E0E0" }} />
    </>
  );
}
